<template>
  <Card :class="'auth-item' + (model.status === 0 ? '-disabled' : '')">
    <strong>{{ model.item }}</strong>
    <span style="font-size: .8em;" v-if="model.route">({{ model.route }})</span>
    <a href="#" @click="edit" slot="extra" title="编辑">
      <Icon type="ios-create" color="#0d6ae6" size="20" />
    </a>
    <a href="#" @click="del" slot="extra" v-if="model.status === 1" title="禁用">
      <Icon type="ios-trash" color="#ff0000" size="20" />
    </a>
    <a href="#" @click="del" slot="extra" v-if="model.status === 0" title="激活">
      <Icon type="ios-undo" color="#55b627" size="20" />
    </a>
    <Modal v-model="showEdit" title="修改子项" :footer-hide="true">
      <edit-item ref="editItem" @refresh="refresh"></edit-item>
    </Modal>
  </Card>
</template>

<script>
import { DeleteItem } from '@/api/auth'
import EditItem from '@/components/auth/EditItem'

export default {
  name: 'item',
  data: function () {
    return {
      showEdit: false
    }
  },
  components: {
    'edit-item': EditItem
  },
  props: ['model'],
  methods: {
    edit: function () {
      this.$refs.editItem.init(this.model)
      this.showEdit = true
    },
    del: function () {
      this.$Modal.warning({
        title: '警告',
        content: '禁用或激活后，用户权限可能受影响，请谨慎操作！',
        onOk: () => {
          DeleteItem(this.model.item).then(async res => {
            this.$Message.success('禁用成功')
            this.$emit('refresh')
          })
        }
      })
    },
    refresh: function () {
      this.$emit('refresh')
    }
  }
}
</script>

<style>
.auth-item-disabled {
  background-color: #e2e2e2;
  text-decoration:line-through;
}
</style>
